export { default } from './ProcessingWithPopupQuizStep';
